'use client';

import React from 'react';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { Rebates } from '@/features/client/Rebates/Rebates';
import { RebatesSection } from '@/features/client/RebatesSection/RebatesSection';

const RebatesPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Rebates"
          title="Find Rebates That Fit Your Home"
          description=""
        />
      </MainSectionLayout>
      <Section styles={{ paddingTop: 20 }} variant="secondary">
        <Container>
          <Rebates />
        </Container>
      </Section>
      <Section variant="secondary">
        <Container>
          <RebatesSection />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default RebatesPage;
